// eslint-no-undef
import React from 'react';
import LoginForm from './LoginForm';
import ForgotPassword from './ForgotPassword';
import Signup from './Signup';
import loginLogo from '../images/ugov_full_white.png';
import '../App.css';

export default class Login extends React.Component {
 
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let successCheck = window.location.href.indexOf('registrationSuccess=true');
    console.log(' successCheck: ' + successCheck);
    console.log(' loginFailureCheck: ' + this.state.loginFailure);
    let inviteCode = '';
    if (window.location.href.indexOf('invite_code') !== -1) {
      inviteCode = window.location.href.match(/invite_code=(.*)/)[1];
    }
    if ((this.state && this.state.showSignup) || inviteCode) {
      return (<Signup inviteCode={inviteCode} />);
    } else if (this.state && this.state.showForgotPassword) {
      return (
        <div className='loginPage'>
          <img className='loginLogo' src={loginLogo} alt='UGov' />
          { successCheck > 0 ? <div className='bannerMessage'>Conta ativada. Bem-vindo ao ugov! Agora você pode fazer login via web e aplicativo móvel. <iframe src='redirect.html' /></div> : '' }
          { this.state.loginFailure ? <div className='bannerMessageRed'>{this.state.message}</div> : '' }
          <br />
          <ForgotPassword mainApp={this.props.mainApp} loginApp={this} />
        </div>
      );
    } else {
      return (
        <div className='loginPage'>
          <img className='loginLogo' src={loginLogo} alt='UGov' />
          { successCheck > 0 ? <div className='bannerMessage'>Conta ativada. Bem-vindo ao ugov! Agora você pode fazer login via web e aplicativo móvel. <iframe src='redirect.html' /></div> : '' }
          { this.state.loginFailure ? <div className='bannerMessageRed'>{this.state.message}</div> : '' }
          <br />
          <LoginForm mainApp={this.props.mainApp} loginApp={this} />
        </div>
      );
    }
  }
}
